var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-progress',{class:_vm.type || '',attrs:{"percentage":_vm.percentage,"stroke-width":12,"show-text":false,"color":_vm.colors}})
}
var staticRenderFns = []

export { render, staticRenderFns }